import EditIcon from '@mui/icons-material/Edit'
import { Button, Container, Divider, Paper, Stack, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react'

import MarkdownCard from '../components/cards/Markdown'
import TiptapEditor from '../components/forms/TiptapEditor'

// Sample markdown content - 常量，引用稳定
const sampleMarkdown = `# Hello World

This is a sample markdown content.

## Subheading

- List item 1
- List item 2
- List item 3

**Bold text** and *italic text* and \`code\`

> This is a blockquote`

// Component section renderer - 移到组件外部，避免每次渲染都创建新函数
const ComponentSection = React.memo(({ title, description, children }) => (
  <Paper elevation={1} sx={{ p: 3, mb: 4 }}>
    <Typography variant="h5" component="h2" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {description}
      </Typography>
    )}
    <Divider sx={{ mb: 3 }} />
    {children}
  </Paper>
))

ComponentSection.displayName = 'ComponentSection'

/**
 * Development Editor Page
 * Displays and tests the TiptapEditor component
 */
const DevEditor = () => {
  const [markdownContent, setMarkdownContent] = useState(sampleMarkdown)

  // 使用 useCallback 来稳定 onChange 回调，避免编辑器重新渲染
  // 使用函数式更新，避免依赖 markdownContent
  const handleMarkdownChange = useCallback((newMarkdown) => {
    setMarkdownContent(newMarkdown)
  }, [])

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <EditIcon color="primary" />
          <Typography variant="h4" component="h1">
            Tiptap Editor Development
          </Typography>
        </Stack>
        <Typography variant="body1" color="text.secondary">
          Tiptap 富文本编辑器组件开发和测试页面。用于预览和测试编辑器的各种功能和状态。支持 Markdown 格式。
        </Typography>
      </Paper>

      {/* Basic Editor Section */}
      <ComponentSection title="Markdown 编辑器" description="支持 Markdown 格式的 Tiptap 编辑器，包含 StarterKit 扩展和 Markdown 支持（粗体、斜体、标题、列表等）">
        <TiptapEditor defaultContent={sampleMarkdown} onChange={handleMarkdownChange} />
      </ComponentSection>

      {/* Markdown Content Preview Section */}
      <ComponentSection title="当前 Markdown 内容" description="编辑器当前内容的 Markdown 格式输出">
        <Stack spacing={2}>
          <Button variant="outlined" onClick={() => console.log('Current Markdown:', markdownContent)}>
            在控制台输出 Markdown
          </Button>
          <Paper elevation={1} sx={{ p: 2 }}>
            <MarkdownCard>{markdownContent}</MarkdownCard>
          </Paper>
        </Stack>
      </ComponentSection>
    </Container>
  )
}

export default DevEditor
